import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Button } from "@remo-co/ui-core/src/components/Button";
import { Container } from "@remo-co/ui-core/src/components/Container";
import { List } from "@remo-co/ui-core/src/components/List";
import { ListItem } from "@remo-co/ui-core/src/components/ListItem";
import { ListItemIcon } from "@remo-co/ui-core/src/components/ListItemIcon";
import { ListItemText } from "@remo-co/ui-core/src/components/ListItemText";
import { PageLoader } from "@remo-co/ui-core/src/components/PageLoader";
import { ScrollableView } from "@remo-co/ui-core/src/components/ScrollableView";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import classNames from "classnames";
import { useI18n } from "i18n";
import AppBarContainer from "modules/app/menu/AppBarContainer";
import benefitBulletPoint from "modules/company/assets/trial-benefit-bullet-point.png";
import { PAGES, usePageTracking } from "modules/tracking";
import useCompany from "modules/company/hooks/useCompany";
import { Errors, trackError } from "modules/monitoring";
import useStyles from "./styles";

export const GetStartedPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { loadCompany } = useCompany();
  const { t } = useI18n(["common", "company", "menu"]);
  const { push } = useHistory();
  const styles = useStyles();
  const { trackPage } = usePageTracking(PAGES.GET_STARTED, {
    manual: true,
  });

  useEffect(() => {
    loadCompany()
      .then((data) => {
        if (!data || !data.isSuccess || !data.plan) {
          setIsLoading(false);
          trackPage();
          return null;
        }

        push("/my-events");
        return null;
      })
      .catch((error) => {
        trackError(error, {
          label: Errors.GET_STARTED_PLAN_CHECK,
        });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isLoading && <PageLoader message={t("common:loading")} />}
      <AppBarContainer hideTitle />
      <ScrollableView withAppBar className={styles.root}>
        <Container
          className={classNames(styles.infoBox, styles.attendeeInfoBox)}
          fullWidth={false}
        >
          <div>
            <Typography variant="h2">
              {t("company:get.started.attendee")}
            </Typography>
            <List>
              {[
                "company:attendee.benefit.1",
                "company:attendee.benefit.2",
                "company:attendee.benefit.3",
              ].map((key) => (
                <ListItem>
                  <ListItemIcon>
                    <img src={benefitBulletPoint} alt="Benefit bullet point" />
                  </ListItemIcon>
                  <ListItemText
                    className={styles.infoBoxListItemText}
                    primary={<Typography variant="h4">{t(key)}</Typography>}
                  />
                </ListItem>
              ))}
            </List>
            <Button
              variant="secondary"
              color="blue"
              className={styles.attendEventsButton}
              aria-label={t("company:get.started")}
              onClick={() => push("/my-events")}
            >
              {t("company:get.started")}
            </Button>
          </div>
        </Container>
        <Container
          className={classNames(styles.infoBox, styles.hostInfoBox)}
          fullWidth={false}
        >
          <Typography variant="h2">{t("company:get.started.host")}</Typography>
          <Typography variant="subtitle1" className={styles.disclaimer}>
            {t("company:get.started.host.disclaimer")}
          </Typography>
          <List>
            {[
              "company:host.benefit.1",
              "company:host.benefit.2",
              "company:host.benefit.3",
            ].map((key) => (
              <ListItem>
                <ListItemIcon>
                  <img src={benefitBulletPoint} alt="Benefit bullet point" />
                </ListItemIcon>
                <ListItemText
                  className={styles.infoBoxListItemText}
                  primary={<Typography variant="h4">{t(key)}</Typography>}
                />
              </ListItem>
            ))}
          </List>
          <Button
            variant="primary"
            color="blue"
            className={styles.startFreeTrialButton}
            aria-label={t("company:create.first.event")}
            onClick={() => push("/create-company")}
          >
            {t("company:create.first.event")}
          </Button>
        </Container>
      </ScrollableView>
    </>
  );
};
